import { oktaAxios } from "@/vue/api/config";

export const CustomerSearchFields = Object.freeze({
  ID: "customerId",
  NAME: "name",
  TENANT_NAME: "tenantName",
  PBX_NAME: "pbxName",
});

const BASE_CUSTOMER_SEARCH_URL = "v1/customers/search";
const PBX_SEARCH_URL = BASE_CUSTOMER_SEARCH_URL + "/pbx";
const TENANT_SEARCH_URL = BASE_CUSTOMER_SEARCH_URL + "/tenant";

export const searchCustomer = async (field, term) => {
  const encodedTerm = encodeURIComponent(term);

  if (
    field === CustomerSearchFields.ID ||
    field === CustomerSearchFields.NAME
  ) {
    return queryCustomers(field, encodedTerm);
  } else if (field === CustomerSearchFields.TENANT_NAME) {
    return getCustomerByTenantName(encodedTerm);
  } else if (field === CustomerSearchFields.PBX_NAME) {
    return getCustomerByPbxName(encodedTerm);
  } else {
    throw new Error(`Trying to query customers on unsupported field: ${field}`);
  }
};

const queryCustomers = (field, encodedTerm, inexactMatch = false) => {
  console.debug("[queryCustomers] Fetching customer data.", {
    field,
    encodedTerm,
    inexactMatch,
  });

  let params = {};
  if (field === CustomerSearchFields.ID) {
    params = { id: encodedTerm };
  } else if (field === CustomerSearchFields.NAME) {
    params = { name: encodedTerm };
  } else {
    throw new Error(`Trying to query customers on unsupported field: ${field}`);
  }

  // See CustomerSearchController in TAP BE R - this will result in a
  // significantly less performant search and put stress on the SMP DB.
  if (inexactMatch) {
    params["inexactMatch"] = "true";
  }

  return oktaAxios.get(BASE_CUSTOMER_SEARCH_URL, { params });
};

const getCustomerByTenantName = async (encodedTerm) => {
  return await oktaAxios.get(TENANT_SEARCH_URL, {
    params: { id: encodedTerm },
  });
};

const getCustomerByPbxName = async (encodedTerm) => {
  return oktaAxios.get(PBX_SEARCH_URL, { params: { name: encodedTerm } });
};
